import { TenantComponentsPanel } from '@features/catalog';
import { useParams } from 'react-router';

/**
 * Which components this museum has, and what turning one on or off does.
 *
 * A shell, not a screen — the same shape as `ClientFlagsTab`, and for the same
 * reason: everything that knows what a component *is* lives in the catalog
 * feature, and this file only says which museum the panel is about. A
 * clients-owned panel reading the components API would put the join against a
 * museum's grants in two features that then have to agree forever.
 *
 * ## What used to be here
 *
 * A `ComingSoonPanel`, whose reasoning was sound at the time: there was nothing
 * grouping entitlement flags yet, so a tab listing components would have had to
 * invent what a component contains. The catalog has since defined it and
 * activation exists — `PUT`/`DELETE /api/components/:id/activations/:tenantId`
 * — so the placeholder goes.
 *
 * Its closing note has survived into the panel: this is a list of buttons, not
 * switches. Activating a component is a chargeable act whose success is not
 * always a clean one, and a switch promises an immediacy and a symmetric
 * reversibility that a charge does not have.
 *
 * ## Why it does not take the target
 *
 * The same reason the flags tab does not. The other tabs are target-scoped
 * because the clients API proxies upstream per environment; components and the
 * grants they write live in this deployment's own tables, so the environment
 * *is* the deployment and there is nothing to put on the query string. The tab
 * href still carries `?env=&slot=` — dropping it would strand the rest of the
 * strip — it simply does not reach this read.
 */
export function ClientComponentsTab() {
    const { tenantId = '' } = useParams();

    return <TenantComponentsPanel tenantId={tenantId} />;
}
